function initializeAllTrendsPopup() {
    const popup = document.getElementById('popup');
    const popupOpenBtn = document.getElementById('show-all-trends');
    const htmlRoot = document.getElementsByTagName('html')[0];
    const body = document.getElementsByTagName('body')[0];
    const popupCloseBtn = document.getElementById('close-all-trends');

    function open() {
        popup?.classList.add('open');
        popup?.classList.remove('out');
        htmlRoot?.classList.add('popup-open');
        body?.classList.add('popup-open');
    }

    function close() {
        popup?.classList.add('out');
        popup?.classList.remove('open');
        htmlRoot?.classList.remove('popup-open');
        body?.classList.remove('popup-open');
    }

    popupOpenBtn.addEventListener('click', () => {
        open();
    });

    popupCloseBtn.addEventListener('click', () => {
        close();
    });
}
initializeAllTrendsPopup();
